
import { mapState, mapActions } from 'vuex'

import Icon from '../../../common/Icon'

export default {
  name: 'HouseAccounts',
  components: { Icon },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      type: 'houseaccount',
      selectedAccountId: null
    }
  },

  mounted() {
    this.setSelectedAccountId()
    console.log(this.selectedAccountId, "ACCOUNT ID")
  },

  computed: {
    ...mapState({
      paymentType: state => state.checkout.type,
      billing: state => state.checkout.billing
    }),
    enabled() {
      const houseAccount = this.billing.find(b => b.type === this.type)
      return !this.disabled && houseAccount && houseAccount?.accounts?.length > 0
    },
    selected() {
      return this.paymentType === this.type
    }
  },
  methods: {
    ...mapActions({
      setPaymentSelection: 'checkout/setPaymentSelection',
    }),
    setSelectedAccountId() {
      const houseAccount = this.billing.find(b => b.type === this.type)
      if (houseAccount && houseAccount.accounts.length > 0) {
        this.selectedAccountId = houseAccount.accounts[0].id
      }
    }
  }
}
